//#region ../r-html/dist/helpers/is-type.js
var createIsTypeof = (type) => (value) => typeof value === type;
var isObjectRaw = createIsTypeof("object");
var isBigint = createIsTypeof("bigint");
var isBoolean = createIsTypeof("boolean");
var isFunction = createIsTypeof("function");
var isNumber = createIsTypeof("number");
var isString = createIsTypeof("string");
var isSymbol = createIsTypeof("symbol");
var isUndefined = createIsTypeof("undefined");
var isNull = (value) => value === null;
var { isArray } = Array;
var isObject = (value) => isObjectRaw(value) && !isNull(value) && !isArray(value);
var isPrimitive = (value) => isBigint(value) || isBoolean(value) || isNumber(value) || isString(value) || isSymbol(value) || isUndefined(value) || isNull(value);
//#endregion
export { isArray, isBigint, isBoolean, isFunction, isNull, isNumber, isObject, isObjectRaw, isPrimitive, isString, isSymbol, isUndefined };
